/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.headerScroll", {
        options: {},

        _create: function () {
            this.header = this.element;

            this.timeout = 0
            this.didScroll;
            this.lastScrollTop = 0;
            this.navbarHeight = this.header.outerHeight();
            this.delta = this.navbarHeight / 2;
            
            $(window).scroll((event) =>{
                //clearTimeout(this.timeout)
                this.didScroll = true;
                
                setTimeout(()=>{
                    if (this.didScroll) {
                        this._hasScrolled();
                        this.didScroll = false;
                    }
                }, 250)
            });     
            
        },

        _hasScrolled() {
            var st = $(window).scrollTop();

            
            // Make sure they scroll more than delta
            if(Math.abs(this.lastScrollTop - st) <= this.delta)
                return;

            if (st > this.lastScrollTop && st > this.navbarHeight){
                this.header.removeClass('nav-down').addClass('nav-up');
            } else {
                // Scroll Up
                if(st + $(window).height() < $(document).height()) {
                    this.header.removeClass('nav-up').addClass('nav-down');
                }
            }                
            this.lastScrollTop = st;
        }

        
    });
})(jQuery);
